import "./Devices.css";
import React, { useEffect, useState } from "react";
import {
  Card,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  TextField,
  FormControl,
  InputLabel,  
  Grid,
  DialogContentText,
  Select,      
  Checkbox,
} from "@mui/material";
import { useSnackbar } from "notistack";
import axios from "axios";
import { makeStyles } from "@mui/styles";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDLoading from "components/MDLoading/MDLoading";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// ICONS
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { fontStyle } from "@mui/system";
import { whitespace } from "stylis";

const useStyles = makeStyles(() => ({
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

function Devices() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const auth = localStorage.getItem("authToken");
  const role = localStorage.getItem("role");
  const user_id = localStorage.getItem("user_id")
  const [loading, setLoading] = useState(false);
  const [allocationDialogOpen, setAllocationDialogOpen] = useState(false);
  const [admins, setAdmins] = useState([]); // Populate with admin data
  const [selectedAdmin, setSelectedAdmin] = useState("");
  const [numberOfDevices, setNumberOfDevices] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [filterOption, setFilterOption] = useState("all");
  const [allAdmins, setAllAdmins] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [selectedRowToDelete, setSelectedRowToDelete] = useState(null);
  const [selectedDeviceIds, setSelectedDeviceIds] = useState([]);
  const [allDevices, setAllDevices] = useState([]);
  const [allDevicesRowData, setAllDevicesRowData] = useState([]);
  const [allAreas, setAllAreas] = useState([]);
  const [selectedDevicesInfo, setSelectedDevicesInfo] = useState([]);
  const rState = useSelector((s) => s.user.userData);
  const [openDialog, setOpenDialog] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [dialogEditData, setDialogEditData] = useState({ user_id: "", name: "", area_id: "" });
  const [values, setValues] = useState({
    device_name: "",
    device_type: "",
    aws_group_id: "",
    aws_thing_name: "",
    aws_end_point: "",
    area_id: "",
    user_id: "",
    camera_name: "",
    current_status: "",
  });
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [addDeviceDialogOpen, setAddDeviceDialogOpen] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [newDeviceData, setNewDeviceData] = useState({
    device_name: "",
    camera_name: "",
    area_id: "",
    device_type: "smartlight",
    current_status: "0",
    user_id: user_id || "",
    aws_group_id: "",
    aws_thing_name: "",
    aws_end_point: "",
  });
  const [editDeviceData, setEditDeviceData] = useState({
    user_id: "",
    device_id: "",
    device_name: "",
    device_type: "smartlight",
    aws_group_id: "",
    aws_thing_name: "",
    aws_end_point: "",
    area_id: "",
    camera_name: "",
    current_status: "0",
  });

  useEffect(() => {
    fetchAllDevices();
    if (role === "superadmin") {
      fetchAllAdmins();
    } else if (role === "admin") {
      fetchAllSubAdmins();
    }
    fetchAllAreas();
  }, [filterOption, role, values.user_id]);

  const fetchAllDevices = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASEURL}/admin/device/getalldevice`,
        { user_id },
        {
          headers: { Authorization: `Bearer ${auth}` },
        }
      );

      if (response.data && Array.isArray(response.data.areas)) {
        let devicesData = response.data.areas.map((device) => ({
          ...device,
          isAllocated: device.user_id !== null && device.user_id !== undefined && device.user_id !== "",
        }));

        if (filterOption === "allocated") {
          devicesData = devicesData.filter((d) => d.user_id !== null && d.user_id !== undefined && d.user_id !== "");
        } else if (filterOption === "unallocated") {
          devicesData = devicesData.filter((d) => d.user_id === null || d.user_id === undefined || d.user_id === "");
        }

        if (values.user_id) {
          devicesData = devicesData.filter((device) => String(device.user_id) === String(values.user_id));
        }

        setAllDevices(response.data.areas);
        createTableRowData(devicesData);
      } else {
        setAllDevices([]);
        createTableRowData([]);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
      enqueueSnackbar("Error Fetching Devices !!!", { variant: "error" });
    }
  };

  const fetchAllAdmins = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASEURL}/admin/users/all-admins`, {
        headers: { Authorization: `Bearer ${auth}` },
      });
      if (res.data?.success) {
        setAllAdmins(res.data.users || []);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchAllSubAdmins = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/admin/users/all-subAdmins`,
        { user_id: user_id },
        {
          headers: { Authorization: `Bearer ${auth}` },
        }
      );
      if (res.data?.success) {
        setAllAdmins(res.data.users || []);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleFilterChange = (event) => {
    setFilterOption(event.target.value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const fetchAllAreas = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/admin/areas/all`,
        { user_id },
        {
          headers: { Authorization: `Bearer ${auth}` },
        }
      );
      if (res.data?.success && Array.isArray(res.data.areas)) {
        setAllAreas(res.data.areas);
      }
    } catch (err) {
      console.log(err);
      enqueueSnackbar("Error Fetching Areas !!!", { variant: "error" });
    }
  };

  const onEditClick = (rowData) => {
    setEditDeviceData({
      device_id: rowData.id || rowData.device_id,
      device_name: rowData.device_name && rowData.device_name !== "-" ? rowData.device_name : "",
      camera_name: rowData.camera_name && rowData.camera_name !== "-" ? rowData.camera_name : "",
      area_id: rowData.area_id || "",
      device_type: rowData.device_type || "smartlight",
      current_status: rowData.raw_status !== undefined && rowData.raw_status !== null ? String(rowData.raw_status) : "0",
      user_id: rowData.user_id || "",
      aws_group_id: rowData.aws_group_id || "",
      aws_thing_name: rowData.aws_thing_name || "",
      aws_end_point: rowData.aws_end_point || "",
    });
    setEditDialogOpen(true);
  };

  const onUpdateDevice = async () => {
    if (!editDeviceData.device_name) {
      return enqueueSnackbar("Please provide a Device Name", { variant: "error" });
    }
    setEditLoading(true);
    try {
      const payload = {
        device_id: editDeviceData.device_id,
        device_name: editDeviceData.device_name,
        camera_name: editDeviceData.camera_name,
        area_id: editDeviceData.area_id ? parseInt(editDeviceData.area_id) : null,
        device_type: editDeviceData.device_type || "smartlight",
        current_status: editDeviceData.current_status || "0",
        user_id: editDeviceData.user_id ? parseInt(editDeviceData.user_id) : parseInt(user_id),
        aws_group_id: editDeviceData.aws_group_id || "",
        aws_thing_name: editDeviceData.aws_thing_name || "",
        aws_end_point: editDeviceData.aws_end_point || "",
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASEURL}/admin/device/add`,
        payload,
        {
          headers: { Authorization: `Bearer ${auth}` },
        }
      );

      if (response.data?.success) {
        enqueueSnackbar("Device Updated Successfully !!!", { variant: "success" });
        setEditDialogOpen(false);
        fetchAllDevices();
      } else {
        enqueueSnackbar(response.data?.result || response.data?.message || "Error Updating Device !!!", { variant: "error" });
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar("Error Updating Device !!!", { variant: "error" });
    } finally {
      setEditLoading(false);
    }
  };

  const onAddDevice = async () => {
    if (!newDeviceData.device_name) {
      return enqueueSnackbar("Please provide a Device Name", { variant: "error" });
    }
    setAddLoading(true);
    try {
      const payload = {
        device_name: newDeviceData.device_name,
        camera_name: newDeviceData.camera_name,
        area_id: newDeviceData.area_id ? parseInt(newDeviceData.area_id) : null,
        device_type: newDeviceData.device_type || "smartlight",
        current_status: newDeviceData.current_status || "0",
        user_id: newDeviceData.user_id ? parseInt(newDeviceData.user_id) : parseInt(user_id),
        aws_group_id: newDeviceData.aws_group_id || "",
        aws_thing_name: newDeviceData.aws_thing_name || "",
        aws_end_point: newDeviceData.aws_end_point || "",
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASEURL}/admin/device/add`,
        payload,
        {
          headers: { Authorization: `Bearer ${auth}` },
        }
      );

      if (response.data?.success) {
        enqueueSnackbar("Device Added Successfully !!!", { variant: "success" });
        setAddDeviceDialogOpen(false);
        setNewDeviceData({
          device_name: "",
          camera_name: "",
          area_id: "",
          device_type: "smartlight",
          current_status: "0",
          user_id: user_id || "",
          aws_group_id: "",
          aws_thing_name: "",
          aws_end_point: "",
        });
        fetchAllDevices();
      } else {
        enqueueSnackbar(response.data?.result || response.data?.message || "Error Adding Device !!!", { variant: "error" });
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar("Error Adding Device !!!", { variant: "error" });
    } finally {
      setAddLoading(false);
    }
  };

  const onCancelEdit = () => {
    setEditDialogOpen(false);
  };

  const createTableRowData = (devicesArr) => {
    const rowDataObjArr = devicesArr.map((device) => ({
      id: device.device_id,
      device_id: device.device_id,
      device_name: device.device_name || "-",
      camera_name: device.camera_name || "-",
      area_id: device.area_id || "",
      area_name: device.area_name || "-",
      device_type: device.device_type || "smartlight",
      current_status: device.current_status === "1" || device.current_status === 1 ? "ON" : "OFF",
      raw_status: device.current_status,
      user_id: device.user_id || "",
      user_name: device.user_name || "-",
      aws_group_id: device.aws_group_id || "",
      aws_thing_name: device.aws_thing_name || "",
      aws_end_point: device.aws_end_point || "",
    }));

    setAllDevicesRowData(rowDataObjArr);
  };
  

  const handleRowSelectionChange = (newSelection) => {
    setSelectedDeviceIds(newSelection);
    // Update the number of selected devices for allocation
    setNumberOfDevices(newSelection.length);
  };

  const handleCheckboxChange = (deviceId) => {
    setSelectedDeviceIds((prevSelected) => {
      if (prevSelected.includes(deviceId)) {
        // Device ID is already selected, so remove it
        return prevSelected.filter((id) => id !== deviceId);
      } else {
        // Device ID is not selected, so add it
        return [...prevSelected, deviceId];
      }
    });
  };
  const handleAllocateClick = () => {
    // Create an array of selected devices' information
    const selectedDevicesInfo = selectedDeviceIds.map((deviceId) => deviceId);
  
    // Open the allocation dialog box and display the selected devices' information
    setAllocationDialogOpen(true);
    setSelectedDevicesInfo(selectedDevicesInfo);
  
    // Fetch either sub-admins or admins based on the logged-in user's role
    if (role === "superadmin") {
      fetchAllAdmins(); // Fetch admins for superadmin
    } else if (role === "admin") {
      fetchAllSubAdmins(); // Fetch sub-admins for admin
    }
  };
  
  

  const handleAllocate = async () => {
    try {
      let startValue = "";
      let endValue = "";
      let userIdValue = 0;
      let areaIdValue = 0;
  
      if (role === "superadmin") {
        userIdValue = values.user_id;
      } else if (role === "admin") {
        areaIdValue = values.area_id;
        userIdValue = values.user_id;
      }
  
      const response = await axios.post(
        `${process.env.REACT_APP_BASEURL}/admin/device/allocatedevices`,
        {
          start: startValue,
          end: endValue,
          devices: selectedDeviceIds, 
          user_id: userIdValue,
          area_id: areaIdValue,
        },
        {
          headers: { Authorization: `Bearer ${auth}` },
        }
      );
  
      if (response.data?.success) {
        enqueueSnackbar("Devices Allocated Successfully !!!", { variant: "success" });
  
        setSelectedDeviceIds([]); 
        // Close the allocation dialog
        setAllocationDialogOpen(false);
      } else {
        enqueueSnackbar("Error Allocating Devices !!!", { variant: "error" });
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar("Error Allocating Devices !!!", { variant: "error" });
    }
  };
  
  
  const onDeleteClick = (rowData) => {
    setSelectedRowToDelete(rowData);
    setDeleteConfirmationOpen(true);
  };
  
  const performDeviceDeletion = async () => {
  
    try {
      const deviceToDelete = selectedRowToDelete; 
      const deviceIdToDelete = deviceToDelete.id;
  
      const response = await axios.post(
        `${process.env.REACT_APP_BASEURL}/admin/device/delete`,
        { 
          device_id: deviceIdToDelete,
          user_id: parseInt(user_id)
        }, 
        {
          headers: { Authorization: `Bearer ${auth}` },
        }
      );
  
      if (response.data?.success) {
        enqueueSnackbar("Device Deleted Successfully !!!", { variant: "success" });
        setDeleteConfirmationOpen(false);
        navigate("/devices")
        fetchAllDevices();
      } else {
        enqueueSnackbar("Error Deleting Device !!!", { variant: "error" });
      }
    } catch (err) {
      console.error(err);
  
      if (err.response && err.response.status === 400) {
        enqueueSnackbar(
          "Error Deleting Device: This device is allocated to an admin or assigned to an area.",
          { variant: "error" }
        );
      } else {
        enqueueSnackbar("Error Deleting Device !!!", { variant: "error" });
      }
    }
  };
  

  const onUpdate = async () => {
    if (Object.values(dialogEditData)?.includes(""))
      return enqueueSnackbar("Please Provide All The Details !!!", { variant: "error" });

    setEditLoading(true);
    const body = { ...dialogEditData };

    await axios
      .put(`${process.env.REACT_APP_BASEURL}/admin/users/update-subadmin`, body, {
        headers: { Authorization: `Bearer ${auth}` },
      })
      .then((res) => {
        if (res.data?.success) {
          const updateIndex = allDevices?.findIndex((u) => u.user_id === body.user_id);
          if (updateIndex === -1)
            return enqueueSnackbar("Error Sub Admin Not Found !!!", { variant: "error" });

          const area_name = allAreas?.find((a) => a.area_id === body.area_id)?.area_name;
          const allDevicesArrTemp = [...allDevices];
          const userObj = { ...allDevices[updateIndex], ...body, area_name };

          allDevicesArrTemp[updateIndex] = userObj;

          setAllDevices(allDevicesArrTemp);
          createTableRowData(allDevicesArrTemp);
          enqueueSnackbar("Sub Admin Updated Successfully !!!", { variant: "success" });
        } else {
          enqueueSnackbar("Error Updating Admin !!!", { variant: "error" });
        }

        setOpenDialog(false);
        setEditLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setEditLoading(false);
        enqueueSnackbar("Error Updating Sub Admin !!!", { variant: "error" });
      });
  };

  const onCloseDialog = (e, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
    setOpenDialog(false);
  };

    const columns = [
      {
        field: "select",
        headerName: "",
        width: 70,
        renderCell: (params) => (
          <input
            type="checkbox"
            checked={selectedDeviceIds.includes(params.row.id)}
            onChange={() => handleCheckboxChange(params.row.id)}
          />
        ),
      },
      {
        field: "device_name",
        headerName: "Device Name",
        width: 180,
      },
      {
        field: "camera_name",
        headerName: "Camera Name",
        width: 180,
      },
      {
        field: "area_name",
        headerName: "Area",
        width: 180,
      },
      {
        field: "current_status",
        headerName: "Status",
        width: 120,
        renderCell: (params) => (
          <span
            style={{
              padding: "4px 10px",
              borderRadius: "12px",
              fontSize: "12px",
              fontWeight: "600",
              color: "#fff",
              backgroundColor: params.value === "ON" ? "#2e7d32" : "#d32f2f",
            }}
          >
            {params.value}
          </span>
        ),
      },
      {
        field: "action",
        headerName: "Action",
        width: 150,
        renderCell: (params) => (
          <div>
            <MDButton
              onClick={() => onDeleteClick(params.row)}
              variant="gradient"
              color="info"
              style={{ minWidth: "unset", padding: "2px 10px", marginRight: "8px" }}
            >
              <DeleteIcon />
            </MDButton>
            <MDButton
              onClick={() => onEditClick(params.row)}
              variant="gradient"
              color="info"
              style={{ minWidth: "unset", padding: "2px 10px" }}
            >
              <EditIcon />
            </MDButton>
          </div>
        ),
      },
    ];

return (
  <DashboardLayout>
    <DashboardNavbar hidebreadcrumbTitle />
    <MDBox pt={3} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
<Grid container direction="row" justifyContent="space-between" alignItems="center">
  <Grid item>
    <MDTypography variant="h6" color="white">
      Devices
    </MDTypography>
  </Grid>
  <Grid item>
    <Grid container alignItems="center" spacing={2}>
      {(role === "superadmin" || role === "admin") && (
        <>
          <Grid item>
          <FormControl sx={{ m: 2, minWidth: 150}} size="small">
            <InputLabel style={{color: "white"}} id="admin-filter-label">
            {role === 'superadmin' ? 'Admin' : 'Sub Admin'} Filter
            </InputLabel>
            <Select
              sx={{ height: "40px" }}
              labelId="admin-filter-label"
              label="Admin Filter"
              value={values.user_id}
              onChange={(e) => setValues({ ...values, user_id: e.target.value })}
              >
              <MenuItem value="">All</MenuItem>
              {allAdmins?.map((a) => (
              <MenuItem key={a?.user_id} value={a?.user_id}>
              {a?.name}
              </MenuItem>
              ))}
              </Select>
</FormControl>
</Grid>
<Grid item>
  <FormControl sx={{ m: 2, minWidth: 150 }} size="small">
    <InputLabel style={{color: "white"}} id="allocation-filter-label">Allocation Filter</InputLabel>
    <Select
      sx={{height: "40px"}}
      labelId="allocation-filter-label"
      label="Allocation Filter"
      value={filterOption}
      onChange={handleFilterChange}
    >
      <MenuItem value="all">All</MenuItem>
      <MenuItem value="allocated">Allocated</MenuItem>
      <MenuItem value="unallocated">Unallocated</MenuItem>
    </Select>
  </FormControl>
</Grid>

          <Grid item>
            <MDButton
              onClick={handleAllocateClick}
              variant="outlined"
              color="white"
              style={{ marginRight: "8px" }}
              disabled={selectedDeviceIds.length === 0}
            >
              Allocate {selectedDeviceIds.length > 0 ? `${selectedDeviceIds.length} Device(s)` : "Devices"}
            </MDButton>
          </Grid>
          <Grid item>
            <MDButton
              onClick={() => setAddDeviceDialogOpen(true)}
              variant="outlined"
              color="white"
              style={{ marginRight: "8px" }}
            >
              Add Device
            </MDButton>
          </Grid>
          <Grid item>
            <MDButton
              onClick={() => navigate("/devices/create")}
              variant="outlined"
              color="white"
            >
              Bulk / Upload
            </MDButton>
          </Grid>
        </>
      )}
    </Grid>
  </Grid>
</Grid>
</MDBox>
            <MDBox pt={3}>
              {loading ? (
                <CircularProgress
                  sx={{ display: "block", color: "#49a3f1", margin: "0 auto 20px" }}
                />
              ) : (
                <DataGrid
                  rows={allDevicesRowData}
                  columns={columns}
                  pageSize={5}
                />
              )}
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>

    <MDLoading open={deleteLoading} />
    {/* Allocation Dialog */}
    <Dialog open={allocationDialogOpen} onClose={() => setAllocationDialogOpen(false)}>
  <DialogTitle>Allocate Device</DialogTitle>
  <DialogContent>
  {/* Display selected devices' information */}
  {selectedDevicesInfo.map((deviceId, index) => (
    <div key={index}>
      Device ID: {deviceId}
    </div>
  ))}
  {/* Other form elements */}
  <MDBox p={1}>
    <TextField
      select
      label={`Select ${role === 'superadmin' ? 'Admin' : 'Sub Admin'}`}
      fullWidth
      className="creatSubAdmin_select"
      margin="dense"
      value={values.user_id}
      onChange={(e) => setValues({ ...values, user_id: e.target.value })}
    >
      {allAdmins?.map((a) => (
        <MenuItem key={a?.user_id} value={a?.user_id}>
          {a?.name}
        </MenuItem>
      ))}
    </TextField>
  </MDBox>
</DialogContent>

  <DialogActions>
    <MDButton onClick={() => setAllocationDialogOpen(false)} color="secondary">
      Cancel
    </MDButton>
    <MDButton onClick={handleAllocate} color="info">
      Allocate
    </MDButton>
  </DialogActions>
</Dialog>
    <Dialog fullWidth maxWidth="md" open={openDialog} onClose={onCloseDialog}>
      <DialogTitle sx={{ color: "#000" }}>Update Sub Admin</DialogTitle>
      <DialogContent>
        <MDBox p={1}>
          <MDInput
            type="text"
            label="Name"
            value={dialogEditData.name}
            name="name"
            margin="dense"
            fullWidth
            onChange={(e) => setDialogEditData({ ...dialogEditData, name: e.target.value })}
          />
        </MDBox>

        <MDBox p={1}>
          <TextField
            select
            label="Select Area"
            fullWidth
            className="subAdmin_select"
            margin="dense"
            onChange={(e) => setDialogEditData({ ...dialogEditData, area_id: e.target.value })}
            value={dialogEditData.area_id}
          >
            {allAreas?.map((a) => (
              <MenuItem key={a?.area_id} value={a?.area_id}>
                {a?.area_name}
              </MenuItem>
            ))}
          </TextField>
        </MDBox>
      </DialogContent>
      <DialogActions>
        <MDButton variant="outlined" color="info" onClick={onCloseDialog} disabled={editLoading}>
          Close
        </MDButton>
        <MDButton
          variant="gradient"
          onClick={onUpdate}
          style={{ backgroundColor: "darkgreen", color: "#fff" }}
          disabled={editLoading}
        >
          Update
        </MDButton>
      </DialogActions>
    </Dialog>
    {/* Edit device dialog */}
    <Dialog
      fullWidth
      maxWidth="sm"
      open={editDialogOpen}
      onClose={onCancelEdit}
    >
      <DialogTitle>Update Device</DialogTitle>
      <DialogContent>
        <MDBox p={1}>
          <MDInput
            type="text"
            label="Device Name"
            value={editDeviceData.device_name}
            name="device_name"
            margin="dense"
            fullWidth
            required
            onChange={(e) =>
              setEditDeviceData({ ...editDeviceData, device_name: e.target.value })
            }
          />
        </MDBox>

        <MDBox p={1}>
          <MDInput
            type="text"
            label="Camera Name"
            value={editDeviceData.camera_name}
            name="camera_name"
            margin="dense"
            fullWidth
            onChange={(e) =>
              setEditDeviceData({ ...editDeviceData, camera_name: e.target.value })
            }
          />
        </MDBox>

        <MDBox p={1}>
          <TextField
            select
            label="Select Area"
            fullWidth
            className="subAdmin_select"
            margin="dense"
            value={editDeviceData.area_id}
            onChange={(e) =>
              setEditDeviceData({ ...editDeviceData, area_id: e.target.value })
            }
          >
            <MenuItem value="">
              <em>None (Unassigned)</em>
            </MenuItem>
            {allAreas?.map((a) => (
              <MenuItem key={a?.area_id} value={a?.area_id}>
                {a?.area_name}
              </MenuItem>
            ))}
          </TextField>
        </MDBox>

        <MDBox p={1}>
          <TextField
            select
            label="Current Status"
            fullWidth
            className="subAdmin_select"
            margin="dense"
            value={editDeviceData.current_status}
            onChange={(e) =>
              setEditDeviceData({ ...editDeviceData, current_status: e.target.value })
            }
          >
            <MenuItem value="0">OFF</MenuItem>
            <MenuItem value="1">ON</MenuItem>
          </TextField>
        </MDBox>

        <MDBox p={1}>
          <TextField
            select
            label={role === "superadmin" ? "Assign to Admin" : "Assign to Sub Admin (Optional)"}
            fullWidth
            className="subAdmin_select"
            margin="dense"
            value={editDeviceData.user_id}
            onChange={(e) =>
              setEditDeviceData({ ...editDeviceData, user_id: e.target.value })
            }
          >
            <MenuItem value={user_id}>
              <em>Myself (Default)</em>
            </MenuItem>
            {allAdmins?.map((a) => (
              <MenuItem key={a?.user_id} value={a?.user_id}>
                {a?.name}
              </MenuItem>
            ))}
          </TextField>
        </MDBox>
      </DialogContent>
      <DialogActions>
        <MDButton
          variant="outlined"
          color="info"
          onClick={onCancelEdit}
          disabled={editLoading}
        >
          Cancel
        </MDButton>
        <MDButton
          variant="gradient"
          color="info"
          onClick={onUpdateDevice}
          disabled={editLoading}
        >
          {editLoading ? <CircularProgress size={20} sx={{ color: "inherit" }} /> : "Update Device"}
        </MDButton>
      </DialogActions>
    </Dialog>

    {/* Add device dialog */}
    <Dialog
      fullWidth
      maxWidth="sm"
      open={addDeviceDialogOpen}
      onClose={() => setAddDeviceDialogOpen(false)}
    >
      <DialogTitle>Add Device</DialogTitle>
      <DialogContent>
        <MDBox p={1}>
          <MDInput
            type="text"
            label="Device Name"
            value={newDeviceData.device_name}
            name="device_name"
            margin="dense"
            fullWidth
            required
            onChange={(e) =>
              setNewDeviceData({ ...newDeviceData, device_name: e.target.value })
            }
          />
        </MDBox>

        <MDBox p={1}>
          <MDInput
            type="text"
            label="Camera Name"
            value={newDeviceData.camera_name}
            name="camera_name"
            margin="dense"
            fullWidth
            onChange={(e) =>
              setNewDeviceData({ ...newDeviceData, camera_name: e.target.value })
            }
          />
        </MDBox>

        <MDBox p={1}>
          <TextField
            select
            label="Select Area"
            fullWidth
            className="subAdmin_select"
            margin="dense"
            value={newDeviceData.area_id}
            onChange={(e) =>
              setNewDeviceData({ ...newDeviceData, area_id: e.target.value })
            }
          >
            <MenuItem value="">
              <em>None (Unassigned)</em>
            </MenuItem>
            {allAreas?.map((a) => (
              <MenuItem key={a?.area_id} value={a?.area_id}>
                {a?.area_name}
              </MenuItem>
            ))}
          </TextField>
        </MDBox>

        <MDBox p={1}>
          <TextField
            select
            label={role === "superadmin" ? "Assign to Admin" : "Assign to Sub Admin (Optional)"}
            fullWidth
            className="subAdmin_select"
            margin="dense"
            value={newDeviceData.user_id}
            onChange={(e) =>
              setNewDeviceData({ ...newDeviceData, user_id: e.target.value })
            }
          >
            <MenuItem value={user_id}>
              <em>Myself (Default)</em>
            </MenuItem>
            {allAdmins?.map((a) => (
              <MenuItem key={a?.user_id} value={a?.user_id}>
                {a?.name}
              </MenuItem>
            ))}
          </TextField>
        </MDBox>
      </DialogContent>
      <DialogActions>
        <MDButton
          variant="outlined"
          color="info"
          onClick={() => setAddDeviceDialogOpen(false)}
          disabled={addLoading}
        >
          Cancel
        </MDButton>
        <MDButton
          variant="gradient"
          color="info"
          onClick={onAddDevice}
          disabled={addLoading}
        >
          {addLoading ? <CircularProgress size={20} sx={{ color: "inherit" }} /> : "Add Device"}
        </MDButton>
      </DialogActions>
    </Dialog>
    {/* Delete confirmation dialog box */}
    <Dialog open={deleteConfirmationOpen} onClose={() => setDeleteConfirmationOpen(false)}>
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this Device?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <MDButton onClick={performDeviceDeletion} color="info">
          Yes
        </MDButton>
        <MDButton onClick={() => setDeleteConfirmationOpen(false)} color="info">
          No
        </MDButton>
      </DialogActions>
    </Dialog>
  </DashboardLayout>
  );
}

export default Devices;